import JsBarcode from 'jsbarcode';

/**
 * Label Print Service
 * Handles barcode generation and label printing
 */

class LabelPrintService {
    /**
     * Generate barcode for a product
     * @param {string} elementId - SVG element ID
     * @param {string} value - Barcode value (SKU)
     */
    generateBarcode(elementId, value) {
        try {
            const element = document.getElementById(elementId);
            if (element && value) {
                JsBarcode(element, value, {
                    format: 'CODE128',
                    width: 2,
                    height: 40,
                    displayValue: true,
                    fontSize: 12,
                    margin: 5
                });
            }
        } catch (error) {
            // console.error('Error generating barcode:', error);
        }
    }

    /**
     * Generate barcodes for all labels before printing
     * @param {Array} products - Array of products with label counts
     */
    generateAllBarcodes(products) {
        products.forEach(product => {
            for (let i = 0; i < product.numberOfLabels; i++) {
                const elementId = `barcode-${product.id}-${i}`;
                this.generateBarcode(elementId, product.barcode || product.sku);
            }
        });
    }

    /**
     * Trigger print dialog
     */
    print() {
        window.print();
    }
}

export default new LabelPrintService();
